import DEMAND_CLASSES from '../../modules/demand_classes.js';

angular.module('vastdesk').
  component('demandTagForwardDealIds',  {
    bindings: {
      formName: '@',
      formId: '@',
      forwardDealIdsEnabled: '<',
      readOnly: '<',
      demandClass: '@'
    },
    template: require("../templates/demandTagForwardDealIds.html"),
    controllerAs: '$demandTagForwardDealIdsCtrl',
    controller: ['$rootScope', '$scope', function($rootScope, $scope) {

      this.forwardDealIdsDisabled = function() {
        return disabledByDemandClass();
      };

      const disabledByDemandClass = () => {
        return ![
          DEMAND_CLASSES.CLASS_DIRECT_CONNECT,
          DEMAND_CLASSES.CLASS_HEADER_BIDDING,
          DEMAND_CLASSES.CLASS_OPEN_RTB_DIRECT_CONNECT
        ].includes(this.demandClass);
      };

      $scope.$on('demandClassChanged', (e, args) => {
        this.demandClass = args.demandClass;
      });

    }]
});
